"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOfTheWeekOption = void 0;
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
/**
 *
 * @param day Dropdown item data
 * @param selectedDays selected days set
 * @returns {Element} element to render as dropdown item
 */
const DayOfTheWeekOption = ({ day, selectedDays, onSelect }) => {
    return (react_1.default.createElement(checkbox_1.default, { checked: selectedDays.has(day.id), name: `week-day-checkbox-${day.id}`, label: day.name, onChange: () => {
            onSelect(day, selectedDays);
        } }));
};
exports.DayOfTheWeekOption = DayOfTheWeekOption;
DayOfTheWeekOption.propTypes = {
    day: (0, prop_types_1.shape)({
        id: prop_types_1.number,
        name: prop_types_1.string
    }),
    selectedDays: prop_types_1.object,
    onSelect: prop_types_1.func
};
//# sourceMappingURL=DayOfTheWeekOption.js.map